//#region IMPORT
import React from 'react';
/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import {
  getColumnDefs1
} from './WOR_BASIC_02_ColumnDefs';
/** Icons Import */

//#endregion
function WOR_BASIC_02(props) {
  //#region 변수
  const columnDefs1 = getColumnDefs1(props);
  const processFieldSet = React.useMemo(() => {
    const cols = props.gongjongColumns ?? [];
    return new Set(cols.map((c) => c.Field ?? c.field ?? '').filter(Boolean));
  }, [props.gongjongColumns]);
  //#endregion

  const rowId = (params) => {
    const no = params.data.no;
    if (no != null) return no;
    return String(params.data.chemSeq ?? params.rowIndex);
  };

  return (
    <React.Fragment>
      <BusinessGridCommon
        getRowId={rowId}
        deleteYn1="Y"
        addYn1="Y"
        addClick1={props.addClick1}
        autoHeaderHeight
        enableRangeSelection
        enableFillHandle
        gridRef={props.gridRef1}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        deleteClick1={(e) => {
          if (!props.validateSelection()) return;
          const newRowExists = props.selectedRowData1?.some(
            (row) => row.newYn === 'Y'
          );
          if (!newRowExists) {
            props.MarkedForDeletion1?.(props.selectedRowData1);
          } else {
            props.NewYnErrorMsg?.();
          }
        }}
        refreshClick1={(e) => {
          if (!props.validateSelection()) return;
          props.SearchLogic1?.();
        }}
        setSelectedRowData={props.setSelectedRowData1}
        setChangedRowData={props.setChangedRowData1}
        onCellValueChanged={(e) => {
          const key = e.data.chemSeq ?? e.data.no;
          props.setChangedRowData1?.((prev) => {
            const filtered = prev.filter(
              (row) => (row.chemSeq ?? row.no) !== key
            );
            return [...filtered, { ...e.data, editYn: 'Y' }];
          });
        }}
        onCellClicked={(e) => {
          const field = e.column?.getColId?.() ?? e.colDef?.field ?? '';
          const isProcessColumn = processFieldSet.has(field);

          if (isProcessColumn) {
            const currentVal = e.data[field];
            const isChecked =
              currentVal === true ||
              currentVal === 'Y' ||
              currentVal === '1' ||
              currentVal === 'O' ||
              currentVal === 'o';
            const newVal = isChecked ? '' : 'O';
            const updatedData = { ...e.data, [field]: newVal, editYn: 'Y' };
            e.node.setDataValue(field, newVal);
            props.setChangedRowData1?.((prev) => {
              const key = e.data.chemSeq ?? e.data.no;
              const filtered = prev.filter(
                (row) => (row.chemSeq ?? row.no) !== key
              );
              return [...filtered, updatedData];
            });
            return;
          }

          const gridApi = props.gridRef1.current?.api;
          const clickedRowIndex = e.rowIndex;
          const isCheckboxClick = e.event?.target?.type === 'checkbox';
          if (!isCheckboxClick && gridApi) {
            gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
            gridApi.setFocusedCell(clickedRowIndex, 'korNm');
            const copied = JSON.parse(JSON.stringify(e.data));
            props.handleRowSelection1?.(copied, clickedRowIndex);
            gridApi
              .getDisplayedRowAtIndex(clickedRowIndex)
              ?.setSelected(true, false);
          }
        }}
        onSelectionChanged={() => {
          const gridApi = props.gridRef1?.current?.api;
          const selectedNodes = gridApi?.getSelectedNodes() ?? [];
          const selectedData = selectedNodes.map((n) => n.data);
          if (props.selectedRowNosRef1?.current) {
            props.selectedRowNosRef1.current = new Set(
              selectedData.map((r) => r.no ?? r.chemSeq)
            );
          }
          props.setSelectedRowData1?.(selectedData);
        }}
      />
    </React.Fragment>
  );
}

export default WOR_BASIC_02;
